import React, { useState } from 'react';
import Modal from '../Modal/Modal';
import ModalForm from '../Modal/ModalForm';
import InputsSection from '../Modal/InputsSection';
import ModalButtons from '../Modal/ModalButtons';
import ModalHeading from '../Modal/ModalHeading';

interface SessionTimeoutModalProps {
  show: boolean;
  onClose: () => void;
  onLogout: () => void;
}

const SessionTimeoutModal: React.FC<SessionTimeoutModalProps> = ({ show, onClose, onLogout }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = () => {
    try {
      setLoading(true);
      setError(null);
      onLogout();
    } catch (err) {
      setError('Failed to clear session. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} modalClassName="session-timeout-modal">
      <ModalHeading heading="Session Timeout" />
      <ModalForm
        style={{ marginBottom: "2.5rem" }}
        onSubmit={handleLogin}
      >
        <InputsSection style={{ width: "34rem" }}>
          <p className="primaryText">
            Your session has expired.
            <br />
            <br />
            <span className="dangerText">Please log in again to continue.</span>
          </p>
          {error && <div className="alert alert-danger mt-2">{error}</div>}
          {loading && (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </InputsSection>

        <ModalButtons
          submitButtonLabel={loading ? 'Redirecting...' : 'Log Out'}
          cancelButtonLabel="Cancel"
          onCancel={onClose}
          loading={loading}
        />
      </ModalForm>
    </Modal>
  );
};

export default SessionTimeoutModal;
